import React, { useContext, useState, useEffect } from "react";
import ListIcon from "../Assets/Icon/ListIcon";
import ListUlIcon from "../Assets/Icon/ListUlIcon";
import SearchIcon from "../Assets/Icon/SearchIcon";
import Player from "../Components/Player";
import Surah from "../Components/Surah";
import { GlobalState } from "../Helper/Context";
import MainReader from "../Helper/MainReader";
import Reader from "../Components/Reader";
const Listen = ({ title }) => {
  document.title = title;
  const [showMode, setShowMode] = useState(window.innerWidth > 440);
  window.addEventListener("resize", () => {
    setShowMode(window.innerWidth > 440);
  });
  const { state, setState } = useContext(GlobalState);
  return (
    <section className="flex flex-col md:flex-row flex-wrap gap-4 relative container m-auto pb-8 px-4">
      <Reader mainReader={MainReader} />
      <main className="h-full max-w-full md:w-[calc(100%-300px)] relative bg-[#F5F7F9] flex-1 rounded-[45px] py-8 pb-0">
        <section className="flex justify-between items-center mb-8 px-8">
          {showMode && (
            <div className="niewMode flex items-center gap-4">
              <ListUlIcon />
              <ListIcon />
            </div>
          )}
          <div className="search flex items-center gap-2">
            <SearchIcon />
            <input
              onChange={(e) => {
                setState({ ...state, search: e.target.value });
              }}
              className=" outline-none bg-transparent"
              type="search"
              placeholder={
                state.langTo === "EN" ? "البحث عن سورة..." : "Search Surah..."
              }
            />
          </div>
        </section>
        <Surah />
        <Player
          reader={state.selectedReader}
          surah={state.selectedSurah}
          langto={state.langTo}
        />
      </main>
    </section>
  );
};

export default Listen;
